export class TenantTeamDto {
  id?: string;
  name: string = '';
  createdAt: Date = new Date();
}
